import React, { Component } from "react";
import Navbar from "../Navbars/Navbar";
import Footer from "components/Footers/Footer";
import "assets/css/safexpay-web.css";
import "../Policy/Policy.css";

class RiskManagement extends Component {
  righthandler = () => {
    document.addEventListener("contextmenu", (event) => event.preventDefault());
  };

  componentDidMount() {
    this.righthandler();
  }
  render() {
    return (
      <>
        <Navbar />
        <main ref="main" className="dv-main">
          <section
            className="dv-HeroBanner dv-Policy"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h1 className="herobanner-heading text-center pt-5 font-w6">
              Risk Management Policy
            </h1>
          </section>
          <section className="dv-Policy-content">
            <div
              className="container font-s19"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div className="row">
                <div className="col-12">
                  <p>
                    <strong style={{ textTransform: "uppercase" }}>
                      Risk Management Process
                    </strong>
                  </p>
                  <p className="mt-4">
                    Online shopping is clearly an excellent opportunity for any
                    merchant to grow the business and increase revenue.
                  </p>
                  <br />
                  <p>
                    However, the threat of online fraud and identity thefts can
                    create damaging leaks to your revenue and has the potential
                    to adversely affect your reputation beyond repair. As an
                    e-Commerce entity your interface with your customer is
                    virtual and therefore reputation and trust are of utmost
                    pertinence in the online business space. Hence, preventing
                    online fraud is a vital task for every successful e-Merchant
                    and it is the foundation of building your reputation online.{" "}
                  </p>
                  <br />
                  <p>
                    The platform has been developed with the combination of best
                    practices, leading technology and human intelligence,
                    Safexpay has developed a 'Fraud & Risk Management Tool’ that
                    makes online transactions safer for our merchants. It is an
                    unparalleled Empirical Fraud Detection engine that provides
                    an unprecedented level of risk detection that can help to
                    improve transaction success rates and reduces both expenses
                    and potential chargeback loss.
                  </p>
                  <br />
                  <p>
                    <strong>HERE IS A QUICK SUMMARY OF THE PROCESS</strong>
                  </p>
                  <p>
                    Once the data is collected from your(merchant’s) customer,
                    every single field is assessed and monitored by our experts
                    and every transaction is mapped against a comprehensive
                    negative database. This helps us trap fraudsters by looking
                    for a match among certain parameters against prior fraud
                    cases and illegal fraudulent activities registered in our
                    system and warn you in time.
                  </p>
                  <br />
                  <p>
                    Each transaction that passes through the Safexpay payment
                    facility is assessed and verified using over 50 parameters.
                    Comprehensive checks and the robust system which helps
                    minimize your risk.{" "}
                  </p>
                  <p>
                    After the assessment transactions are flagged as High Risk
                    if any suspicious activity is noted and where the
                    transaction is marked high risk, you will need to provide
                    additional data as specified by our risk team to process the
                    transaction. And even you have the power and an intelligent
                    choice to process the flagged transaction at your own
                    discretion.
                  </p>
                  <br />
                  <p>
                    <strong>
                      A SNAPSHOT OF SOME PARAMETER CHECKS WE PERFORM:{" "}
                    </strong>
                  </p>

                  <b style={{ fontWeight: "bold" }}>
                    Address Verification System (AVS){" "}
                  </b>

                  <p>
                    It identifies the person claiming to own the credit card.
                    The system crosschecks the billing details of the credit
                    card provided by the user against the address at the issuing
                    bank of the credit card.
                  </p>

                  <b style={{ fontWeight: "bold" }}>CVV Matching </b>

                  <p>
                    It verifies whether the person making the transaction is in
                    possession of the credit card by validating the three-digit
                    code on the back of the card.
                  </p>
                  <p>
                    <strong>Negative and Positive Databases </strong>
                  </p>
                  <p>
                    Checks against Negative Database is done to identify those
                    who have done fraud or chargebacks in the past. Checks
                    against Positive Database are also done to recognize trusted
                    customers who have made genuine online payments in the past.
                    These processes help weed- out bad transactions and to speed
                    up retention of good and genuine customers.
                  </p>

                  <b style={{ fontWeight: "bold" }}>
                    Geo-IP Address Verification{" "}
                  </b>

                  <p>
                    It flags transactions coming from a suspicious computer
                    configuration or categorically high-risk regions.
                  </p>

                  <b style={{ fontWeight: "bold" }}>Bin Checks </b>

                  <p>
                    It validates the card-issuing bank by checking the BIN (Bank
                    Identification Number) on the Credit Card.
                  </p>

                  <b style={{ fontWeight: "bold" }}>Velocity Checking </b>

                  <p>
                    It screens multiple payments that come from the same IP
                    address by checking for repeated transaction attempts from
                    the same computer or network.
                  </p>
                  <b style={{ fontWeight: "bold" }}>
                    Components of our fraud transaction monitoring{" "}
                  </b>
                  <p>
                    We have an effective monitoring system that comprises of the
                    following components:{" "}
                  </p>
                  <ul>
                    <li>
                      <b>Monitoring by front-line staff:</b> Front-line staff
                      knows the most about customers and their typical patterns
                      of transaction activities. They are in the best position
                      to identify unusual activities. We provide regular
                      training to front-line staff to foster a high level of
                      awareness in them. The training provided covers the fraud
                      risks associated with the operations for which front-line
                      staff is responsible. Our team also attends the seminars
                      and conferences organized by different schemes.
                    </li>

                    <li>
                      <b>Monitoring past transactions:</b> Our team periodically
                      reviews MIS reports and/or alerts, as well as the
                      establishment of proper review procedures to ensure that
                      customer transactions are monitored on a risk-sensitive
                      basis. Periodic transaction- monitoring reports covers
                      should at the minimum covers unusually large or frequent
                      transactions.
                    </li>
                    <li>
                      <b>Identification of suspicious transactions:</b> To
                      determine whether a transaction or activity is unusual or
                      suspicious (fraudulent), an effective
                      transaction-monitoring system is in place that includes
                      procedures to not only evaluate the current transactions
                      of customers, but also the pattern of transactions and
                      transaction flow. The current transaction is compared with
                      past transaction patterns and the customer’s risk profile.
                    </li>
                    <li>
                      <b>Management of suspicious transactions:</b> Our
                      monitoring system identifies suspicious transactions
                      identified and then these transactions are carefully
                      examined and investigated, the follow-up action taken
                      tracked and proper audit trails maintained for inspection
                      by auditors and the regulator. It is therefore important
                      that proper policies and procedures on transaction
                      monitoring are developed and maintained by banks and
                      financial institutions. The procedures should clearly set
                      out the responsibilities of individual departments, e.g.,
                      the Business, Compliance, Fraud, Risk and Audit
                      departments, engaged in transaction monitoring.
                    </li>
                    <li>
                      <b>Review of processes and system parameters:</b>{" "}
                      Regardless of whether an automated system is used,
                      effective monitoring requires regular review and updating
                      of the parameters or criteria used to generate monitoring
                      reports or issue alerts. We at Safexpay emphasize on
                      Regular enhancements in our system and processes with
                      respect to the overall fraud and risk management of
                      transactions which also considers changes in business
                      operations and new fraud typologies. Any
                      enhancements/changes in the system is properly documented
                      and approved by the management.
                    </li>

                    <li>
                      <b>Management commitment:</b> We at Safexpay give the
                      utmost importance to transaction monitoring and
                      management. Prerequisite for establishing and maintaining
                      an effective transaction-monitoring system is the support
                      and commitment of an organization’s senior management. Our
                      management is highly committed towards continual
                      enhancement of our fraud and risk management systems. No
                      transaction-monitoring system can be effective in the
                      absence of adequate resources to maintain and operate the
                      system.{" "}
                    </li>
                  </ul>

                  <p>
                    <strong>DISPUTE</strong>
                  </p>
                  <p>
                    Dispute is a disagreement against a transaction raised by
                    the cardholder (end-user) and reported to their card issuing
                    bank.{" "}
                  </p>
                  <p>
                    A Dispute is a provision by banks and card networks such as
                    Visa &amp; MasterCard to protect buyers from unauthorized or
                    fraudulent payments. Once the cardholder files a complaint,
                    the bank reports the same to payments platform and initiates
                    an investigative procedure.{" "}
                  </p>
                  <p>
                    <b style={{ fontWeight: "bold" }}>Reasons of Dispute:</b>{" "}
                    There could be several reasons of Dispute against a
                    transaction. A list of the most common reasons of Dispute is
                    listed below.{" "}
                  </p>
                  <ul>
                    <li>A customer has not received goods or a service.</li>
                    <li>The received goods or service are not as described.</li>
                    <li>
                      The customer needs more details, such as a copy of the
                      transaction or a receipt.
                    </li>
                    <li>
                      I have neither incurred nor authorised the above
                      transactions{" "}
                    </li>
                  </ul>
                  <p>
                    Generally, Disputes can be associated with unsatisfactory
                    customer service/product or poor service delivery
                    experience. Disputes can also be filed if the customer
                    suspects fraudulent activity on their card.
                  </p>
                  <p>
                    <b style={{ fontWeight: "bold" }}>
                      Higher Disputes Ratio :
                    </b>{" "}
                    It is best to avoid any kind of Dispute, as banks and card
                    networks can label your business as a fraudulent/high risk
                    business, hampering your image. A customer has a right to
                    file a Disputes for the transaction made, which means your
                    sales are reversible for that amount. A high number of
                    Disputes can lead to the banks holding remittances for the
                    business as well. The worst-case scenario could be a ban of
                    online payment services imposed upon the business.
                  </p>
                  <p>
                    <strong>Dispute Resolution Process:</strong>
                  </p>
                  <p>
                    Disputes should be considered high priority issues due to
                    the involvement of risk teams of both the customer’s bank as
                    well as our partner banks.{" "}
                  </p>
                  <p>
                    <b style={{ fontWeight: "bold" }}>
                      Notification about the dispute :
                    </b>{" "}
                    We will notify you by email/telephone about the dispute,
                    mentioning the payment ID and the reason of Dispute, if
                    provided by the bank.
                  </p>
                  <p>
                    <strong>Review the Dispute </strong>
                  </p>
                  <p>
                    To represent the Dispute, review the Dispute and explain to
                    us the chain of events that took place.
                  </p>
                  <ul>
                    <li>
                      In case the goods/services have not been provided, review
                      the issue and let us know if the customer is willing to
                      accept the goods/services.{" "}
                    </li>
                    <li>
                      In case the goods/services have been provided, share the
                      proof of deliveries, invoices, any other authorised proof
                      of product/service delivery.{" "}
                    </li>
                    <li>
                      In case of a duplicate payment made, let us know so we can
                      ask the bank to refund the amount back to the cardholder.{" "}
                    </li>
                  </ul>
                  <p>
                    <strong>Share documents </strong>
                  </p>
                  <p>
                    Share all documents as per the requirement of the bank with
                    us. We will represent the dispute on your behalf.
                  </p>
                  <p>
                    <strong>Process of Dispute handling </strong>
                  </p>
                  <p>
                    In case of any disputed transaction (frauds and no service
                    rendered cases) raised by the acquiring banks, we at
                    Safexpay intimate the concerned merchant about the
                    transaction and seek their reviews and details based on the
                    aspect of dispute. After obtaining the evidence from the
                    merchant, the same is shared with the respective bank for
                    their perusal.
                  </p>
                  <p>
                    Resolution and closure of Disputes: based on the
                    investigation of bank and Safexpay a decision is taken with
                    respect to the disputed transaction either to disable the
                    merchant or implement proper measures to mitigate the root
                    cause of such transactions.
                  </p>
                  <p>
                    <strong>Chargeback Management: </strong>
                  </p>
                  <p>
                    Chargeback is a process that allows the customer to reverse
                    all kind of transactions when there is a problem with the
                    goods or services they've purchased using any of these
                    options.
                  </p>
                  <p>
                    Safexpay has automated process of chargeback management
                    where Safexpay mark chargeback in system and automated email
                    flow to merchant to submit documents. Merchant can upload
                    the documents on merchant portal as per acquiring bank TAT.{" "}
                  </p>
                  <p>
                    Safexpay Operation’s team will verify the document and send
                    it to acquiring bank for Verification. Acquiring banks
                    verify the document and accordingly send it to schemes.
                    Visa/Master/issuing bank to investigate the chargeback and
                    update the status to acquiring bank as per TAT. Safexpay put
                    payment on hold till update from acquiring bank comes.
                    Depending on Acquiring bank revert, Safexpay reverse the
                    amount to customer or make the payment to merchant. Safexpay
                    follows CTS ratio as per acquiring bank.{" "}
                  </p>

                  <p>
                    <strong>Reason for Chargeback </strong>
                  </p>
                  <p>
                    Chargebacks are common practice and sometimes unavoidable.
                    There are multiple reasons why a buyer would request a
                    chargeback, but most fall under these explanations.
                  </p>
                  <p>
                    <strong>Fraudulent transactions </strong>
                  </p>
                  <p>
                    This happens when the credit card is used without the
                    authorization of the credit card holder. Merchant is fully
                    responsible to remedy this chargeback reason. For example:
                    the credit card is stolen and used to make purchases at the
                    merchant’s online store.
                  </p>
                  <p>
                    <strong>Service dispute </strong>
                  </p>
                  <p>
                    Disputes can occur when buyers feel that a service was not
                    rendered, or an item was not as described. In these cases,
                    buyers will often request a chargeback. Merchant is fully
                    responsible to remedy this chargeback reason. Example: an
                    item purchased in a merchant’s online store does not match
                    the description.
                  </p>
                  <p>
                    <strong>Process of chargeback </strong>
                  </p>
                  <p>
                    In case of any Chargeback reported by the acquiring bank an
                    immediate query is raised with the merchant to obtain
                    documents for representation of the case such documents will
                    include Service Rendered Proof Service, Invoice Receipt, and
                    Delivery Receipt of the Product.
                  </p>
                  {/* <br />
                  <br />
                  <br />
                  <br />
                  <p>
                    <strong>NOTICE </strong>
                  </p>
                  <p>
                    This is a controlled document. Unauthorized access, copying
                    and replication is prohibited.
                  </p>
                  <p>
                    This document must not be copied in whole or in parts by any
                    means, without written authorization of the COO, Paygate
                    India Private Limited (“Safexpay”).{" "}
                  </p> */}
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    );
  }
}

export default RiskManagement;
